import React from "react";
import DashboardBarChart from "../../common/DashboardBarChart";
import NoData from "../../common/NoData";

const ProgressWidget = ({ data, loading }) => {
  if (loading) {
    return (
      <div className="bg-white rounded-lg shadow p-6 animate-pulse">
        Loading...
      </div>
    );
  }

  if (!data || !data.physicalProgress) {
    return <NoData />;
  }

  const progressData = Object.entries(data.physicalProgress).map(
    ([key, value]) => ({
      name: key.replace("% Complete", ""),
      count: value.count,
      percentage: parseFloat(value.percentage),
    })
  );

  return (
    <div className="bg-white">
      <div className="flex justify-between items-center mb-6">
        <h3 className="text-xl my-2 p-0 text-[#3A3A3A] font-bold uppercase text-balance">
          Physical Progress Average (
          {data.averagePhysicalProgress || "0"}%)
        </h3>
        {/* <div className="text-right">
          <p className="text-sm text-gray-600">Average Progress</p>
          <p className="text-2xl font-bold text-teal-700">
            {data.averagePhysicalProgress || "0"}%
          </p>
        </div> */}
      </div>

      <DashboardBarChart
        items={progressData.map((item) => ({
          name: item.name,
          count: item.count,
          percentage: item.percentage.toFixed(1),
        }))}
        unit="features"
      />
    </div>
  );
};

export default ProgressWidget;
